export const propertyMap = {
  population: [100000000.0, 50000000.0, 7000000.0, 1000000.0, 0],
  density: [1000, 900, 800, 300, 0],
  males: [50000000.0, 20000000.0, 3500000.0, 600000.0, 0],
  females: [50000000.0, 20000000.0, 3000000.0, 600000.0, 0],
  sexRatio: [1000, 950, 900, 700, 0],
  urban: [30000000.0, 10000000.0, 1000000.0, 600000.0, 0],
  rural: [60000000.0, 20000000.0, 3000000.0, 500000.0, 0],

  color: [
    [3, 4, 94],
    [2, 62, 138],
    [0, 150, 199],
    [0, 180, 216],
    [144, 224, 239]
  ]
};
